import { useEffect, useState } from "react";
import { errorNotify, sucessNotify } from "../../../services/toast.notification";
import { useForm } from "../../../utility/useForm";
import { NoValidateForm } from "../../../utility/validationRules";
import { FormProps } from '../../../utility/types';
import Spinner from "../../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../../components/FormContainer/FormContainer";
import { AssignLab, getLabList, newCenteralInstall } from "../../../api/api";
import CustomSelect from "../../../components/_common/CustomSelect";
import { useAppDispatch, useAppSelector } from "../../../redux/store/storehooks";
import { UpdateLabList } from "../../../redux/reducers/lablistSlice";


export const AssignLabDialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(NoValidateForm) as any
    const myStore = useAppSelector((state) => state)
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        _getLabList();
    }, [])



    const _getLabList = () => {

        getLabList()
            .then((result: any) => {
                dispatch(UpdateLabList({ labList: result.data.data }))
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const onSubmitForm = (e: any) => {
        e.preventDefault();

        setIsSubmiting(true)

        AssignLab(
            modelMaper()).then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
                onCancel();
                setIsSubmiting(false)
            })
            .catch((error) => {
                console.log(error);
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }
    const modelMaper = () => {
        let model: any = {}
        model.number = payLoad.callernumber
        model.labid = Number(values.labId)
        model.name = myStore.labList.list.find((item: any) => item.prk_AndriodLab_AutoID ===  Number(values.labId)).str_LabPersianName
        return model
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                    <Spinner />
                )}
                {isLoading === false && (

                    <FormContainer title="انتصاب آزمایشگاه" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomSelect
                                    name="labId"
                                    placeholder="آزمایشگاه"
                                    itemList={myStore.labList.list}
                                    value={values.labId || ""}
                                    onChange={handleChange}
                                    valueObjectField={"prk_AndriodLab_AutoID"}
                                    displayObjectField={"str_LabPersianName"}
                                />
                            </Col>
                        </Row>

                    </FormContainer>

                )}
            </>

        </Modal>
    )
}